/* NeuroPulse · barra corrida, cabeçalho, painéis do desktop e gaveta do celular (v4, 2026-10-09) */
(function(){
  var raiz = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* barra corrida: velocidade constante (40 px/s) em qualquer largura; clona o grupo até cobrir a tela */
  document.querySelectorAll('[data-npa]').forEach(function(b){
    var tr = b.querySelector('.npa__track'), g = tr && tr.querySelector('.npa__grp'); if (!g) return;
    function monta(){
      Array.prototype.slice.call(tr.children, 1).forEach(function(e){ e.remove(); });
      var w = g.getBoundingClientRect().width || 1, n = Math.max(1, Math.ceil(innerWidth / w));
      for (var i = 1; i < n * 2; i++) { var c = g.cloneNode(true); c.setAttribute('aria-hidden', 'true'); tr.appendChild(c); }
      tr.style.setProperty('--npa-dur', Math.round(w * n / 40) + 's');   /* o loop corre metade da faixa (n grupos) */
    }
    monta(); var t; addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(monta, 200); });
  });

  var h = document.querySelector('[data-nph]'); if (!h) return;
  var sec = h.closest('.shopify-section') || h;
  var g = document.getElementById('npg'), burger = h.querySelector('[data-npg-open]');
  if (g) document.body.appendChild(g);   /* um pai com transform prenderia o position:fixed */

  /* preso: sombra leve ao rolar; no celular some ao descer e volta ao subir. --nph-h guarda a altura visível (a galeria da PDP usa) */
  var ultimo = scrollY, pend = false;
  function altura(){ raiz.style.setProperty('--nph-h', (sec.classList.contains('is-hidden') ? 0 : h.offsetHeight) + 'px'); }
  function rol(){
    pend = false;
    var y = scrollY, cel = innerWidth < 990, aberto = g && g.classList.contains('is-open');
    h.classList.toggle('is-scrolled', y > 10);
    if (cel && !aberto) { if (y > ultimo + 4 && y > 160) sec.classList.add('is-hidden'); else if (y < ultimo - 4 || y < 160) sec.classList.remove('is-hidden'); }
    else sec.classList.remove('is-hidden');
    ultimo = y; altura();
  }
  addEventListener('scroll', function(){ if (!pend) { pend = true; requestAnimationFrame(rol); } }, { passive: true });
  addEventListener('resize', rol); rol();

  /* painéis do desktop: abrem ao passar o rato, ao focar e ao clicar no chevron; fecham ao sair, com Escape e com clique fora */
  var aberto = null, tm = 0;
  function painel(lk){ return document.getElementById(lk.getAttribute('data-nph-mega')); }
  function abre(lk){
    clearTimeout(tm); if (innerWidth < 990) return;
    if (aberto && aberto !== lk) fecha(aberto, true);
    var p = painel(lk); if (!p) return;
    p.classList.add('is-open'); lk.classList.add('is-on'); lk.setAttribute('aria-expanded', 'true'); aberto = lk;
  }
  function fecha(lk, ja){
    var f = function(){ var p = painel(lk); if (p) p.classList.remove('is-open'); lk.classList.remove('is-on'); lk.setAttribute('aria-expanded', 'false'); if (aberto === lk) aberto = null; };
    if (ja) f(); else { clearTimeout(tm); tm = setTimeout(f, 170); }
  }
  h.querySelectorAll('[data-nph-mega]').forEach(function(lk){
    var p = painel(lk); if (!p) return;
    lk.addEventListener('mouseenter', function(){ abre(lk); });
    lk.addEventListener('mouseleave', function(){ fecha(lk); });
    lk.addEventListener('focus', function(){ abre(lk); });
    p.addEventListener('mouseenter', function(){ clearTimeout(tm); });
    p.addEventListener('mouseleave', function(){ fecha(lk); });
    p.addEventListener('focusout', function(e){ if (!p.contains(e.relatedTarget) && e.relatedTarget !== lk) fecha(lk, true); });
  });
  addEventListener('keydown', function(e){ if (e.key === 'Escape' && aberto) { var lk = aberto; fecha(lk, true); lk.focus(); } });
  document.addEventListener('click', function(e){ if (aberto && !h.contains(e.target)) fecha(aberto, true); });

  /* gaveta do celular: trava a rolagem, prende o foco, Escape fecha e devolve o foco ao botão */
  if (g && burger) {
    var painelG = g.querySelector('.npg__p'), corpo = g.querySelector('.npg__body');
    var abrir = function(v){
      g.classList.toggle('is-open', v); g.setAttribute('aria-hidden', v ? 'false' : 'true');
      burger.setAttribute('aria-expanded', v ? 'true' : 'false'); raiz.style.overflow = v ? 'hidden' : '';
      if (v) { sec.classList.remove('is-hidden'); if (corpo) corpo.scrollTop = 0; setTimeout(function(){ painelG && painelG.focus({ preventScroll: true }); }, 80);   /* foco no painel, não no X: sem anel de foco ao abrir pelo toque */ } else burger.focus();
    };
    burger.addEventListener('click', function(){ abrir(true); });
    g.querySelectorAll('[data-npg-close]').forEach(function(e){ e.addEventListener('click', function(){ abrir(false); }); });
    g.querySelectorAll('[data-npg-link]').forEach(function(a){ a.addEventListener('click', function(){ if (a.pathname === location.pathname) abrir(false); }); });
    addEventListener('keydown', function(e){
      if (!g.classList.contains('is-open')) return;
      if (e.key === 'Escape') abrir(false);
      if (e.key === 'Tab') {
        var f = g.querySelectorAll('a[href],button:not([disabled])'); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    addEventListener('resize', function(){ if (innerWidth >= 990 && g.classList.contains('is-open')) abrir(false); });
  }

  /* relógio: até a meia-noite local (o mesmo da PDP e do "Ends Midnight!" do Kaching) */
  var rel = document.querySelectorAll('[data-np-cd]');
  if (rel.length) {
    var p2 = function(v){ return (v < 10 ? '0' : '') + v; };
    var tique = function(){
      var n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0); var s = Math.max(0, Math.floor((m - n) / 1000));
      var v = [p2(Math.floor(s / 3600)), p2(Math.floor(s % 3600 / 60)), p2(s % 60)];
      rel.forEach(function(e){ e.querySelectorAll('b').forEach(function(b, i){ b.textContent = v[i]; }); });
    };
    tique(); setInterval(tique, 1000);
  }

  /* ícone do carrinho: o tema troca o conteúdo do #cart-icon-bubble quando o carrinho muda; refazemos o nosso desenho com o número novo */
  var bub = document.getElementById('cart-icon-bubble');
  if (bub && bub.querySelector('.nph__bag') && 'MutationObserver' in window) {
    var BAG = bub.querySelector('.nph__bag').outerHTML;
    var mo = new MutationObserver(function(){
      if (bub.querySelector('.nph__bag')) return;
      var c = bub.querySelector('.cart-count-bubble'), sp = c && c.querySelector('[aria-hidden]'), n = c ? (sp ? parseInt(sp.textContent, 10) || 0 : 99) : 0;
      mo.disconnect();
      bub.innerHTML = BAG + (n > 0 ? '<span class="nph__count">' + (n > 99 ? '99+' : n) + '</span>' : '');
      bub.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
      mo.observe(bub, { childList: true });
    });
    mo.observe(bub, { childList: true });
  }
  if (reduce) sec.style.transition = 'none';

  /* só na prévia: ?open=shop|learn abre um painel, ?drawer=1 abre a gaveta */
  
})();
